module.exports = __webpack_public_path__ + "static/media/settings.4d39ff79.png";